import type { FC } from "react";

import { cn } from "@/lib/utils";

import type { CardsElementProps } from "../types";

export const CustomCardFooter: FC<CardsElementProps> = ({
  children,
  classes,
}) => {
  return (
    <div
      className={cn(
        "flex w-full justify-between py-6 px-4 md:px-8 border-t border-gray-200",
        classes
      )}
    >
      {children}
    </div>
  );
};
